import { render, staticRenderFns } from "./DriverUserHealth.vue?vue&type=template&id=1cc34928&scoped=true&"
import script from "./DriverUserHealth.vue?vue&type=script&lang=js&"
export * from "./DriverUserHealth.vue?vue&type=script&lang=js&"
import style0 from "./DriverUserHealth.vue?vue&type=style&index=0&id=1cc34928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc34928",
  null
  
)

export default component.exports